module.exports = __webpack_public_path__ + "img/013.b1137a6a.jpg";